import React from 'react';
import VerifyEmailContainer from '../../../../Containers/UserContainer/Register/VerifyEmail';

const VerifyEmailScreen = () => {
  return <VerifyEmailContainer />;
};

export default VerifyEmailScreen;
